<template>
        <div class="col-sm-3 pb-3 entity-row-6" >
            <img class="img-fluid" v-bind:src="this.cmsUrl + doorCheckDoorImage.image.image_url" v-bind:alt="doorCheckDoorImage.image.alt_text">

            <!--
            <button
                    v-on:click="removePhoto"
                    ref="removePhotoButton"
                    class="btn btn-outline-danger btn-square mt-3 w-100"
                    v-bind:data-door-check-door-image-id="doorCheckDoorImage.door_check_door_image_id"
                    style="margin: 0 5px;"
            >Remove Photo<br>From Door</button>-->

        </div>
</template>

<script>

    export default {
        props: ['doorCheckDoorImage'],
        methods: {
            removePhoto() {
                var button = this.$refs.removePhotoButton;
                var doorCheckDoorImageId = button.dataset.doorCheckDoorImageId;
                this.$swal({
                    title: 'Are you sure?',
                    text: 'Are you sure you want to remove this photo from the door?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    closeOnConfirm: false,
                    showLoaderOnConfirm: true,
                    buttons: {
                        cancel: {
                            text: 'Cancel',
                            value: null,
                            visible: false,
                            className: 'btn btn-square btn-sm btn-secondary',
                            closeModal: true,
                        },
                        confirm: {
                            text: 'Yes',
                            value: true,
                            visible: true,
                            className: 'btn btn-square btn-sm btn-primary',
                            closeModal: true
                        }
                    }
                }).then((result) => {
                    if (result.value) {
                        axios.post(this.cmsUrl + 'api/v1/door-check-doors/remove-photo-from-door.json', {id: doorCheckDoorImageId}, {headers: {'Authorization': 'Bearer '+this.$session.get('user_token')}})
                            .then(response => {
                                if (response.data.status) {
                                    this.reload()
                                } else {
                                    this.$swal('Sorry', response.data.message, 'info')
                                }
                            }).catch(error => {
                                this.$swal('Sorry', 'There was a problem. Please try again.', 'info')
                            });
                    }
                });
            },
            reload() {
                window.location = '';
            }
        },
    }
</script>